import api from './api';
import { SliderItem } from '../types';

export interface CreateSliderItemData {
  title: string;
  description: string;
  link?: string;
  active: boolean;
  image?: File;
  mobile_image?: File;
  category_id?: string | null; // Categoría para contenedor 1
  container_products: {
    container2: string | null;
    container3: string | null;
    container4: string | null;
    container5: string | null;
  };
}

export interface UpdateSliderItemData {
  title: string;
  description: string;
  link?: string;
  active: boolean;
  position: number;
  image?: File;
  mobile_image?: File;
  category_id?: string | null; // Categoría para contenedor 1
  container_products: {
    container2: string | null;
    container3: string | null;
    container4: string | null;
    container5: string | null;
  };
}

export interface SliderOrderItem {
  id: string;
  position: number;
}

export const sliderService = {
  getSliderItems: async (): Promise<SliderItem[]> => {
    const response = await api.get('/slider');
    return (response.data.items || []).map((item: any) => ({
      id: item.id,
      title: item.title,
      description: item.description,
      image_url: item.image_url,
      mobile_image_url: item.mobile_image_url,
      link: item.link,
      active: Boolean(item.active),  // Asegurarse de que se convierta correctamente a booleano
      position: item.position,
      category_id: item.category_id || null, // Categoría para contenedor 1
      container_products: {
        container2: item.product_id || null,
        container3: item.product_id_2 || null,
        container4: item.product_id_3 || null,
        container5: item.product_id_4 || null
      }
    }));
  },
  
  getSliderItem: async (id: string): Promise<SliderItem> => {
    const response = await api.get(`/slider/${id}`);
    return response.data;
  },
  
  createSliderItem: async (data: CreateSliderItemData): Promise<SliderItem> => {
    const formData = new FormData();
    formData.append('title', data.title);
    formData.append('description', data.description);
    if (data.link) formData.append('link', data.link);
    formData.append('active', data.active ? '1' : '0');
    if (data.image) formData.append('image', data.image);
    if (data.mobile_image) formData.append('mobile_image', data.mobile_image);
    if (data.category_id) formData.append('category_id', data.category_id);
    formData.append('product_id', data.container_products.container2 || '');
    formData.append('product_id_2', data.container_products.container3 || '');
    formData.append('product_id_3', data.container_products.container4 || '');
    formData.append('product_id_4', data.container_products.container5 || '');
    
    const response = await api.post('/slider', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    // Transformar la respuesta del backend al formato esperado por el frontend
    const item = response.data.item;
    return {
      id: item.id,
      title: item.title,
      description: item.description,
      image_url: item.image_url,
      mobile_image_url: item.mobile_image_url,
      link_url: item.link,
      active: Boolean(item.active),
      position: item.position,
      category_id: item.category_id || null,
      container_products: {
        container2: item.product_id || null,
        container3: item.product_id_2 || null,
        container4: item.product_id_3 || null,
        container5: item.product_id_4 || null
      }
    };
  },
  
  updateSliderItem: async (id: string, data: UpdateSliderItemData): Promise<SliderItem> => {
    const formData = new FormData();
    formData.append('title', data.title);
    formData.append('description', data.description);
    if (data.link) formData.append('link', data.link);
    formData.append('active', data.active ? '1' : '0');
    formData.append('position', data.position.toString());
    if (data.image) formData.append('image', data.image);
    if (data.mobile_image) formData.append('mobile_image', data.mobile_image);
    if (data.category_id) formData.append('category_id', data.category_id);
    formData.append('product_id', data.container_products.container2 || '');
    formData.append('product_id_2', data.container_products.container3 || '');
    formData.append('product_id_3', data.container_products.container4 || '');
    formData.append('product_id_4', data.container_products.container5 || '');
    
    const response = await api.put(`/slider/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    // Transformar la respuesta del backend al formato esperado por el frontend
    const item = response.data.item;
    return {
      id: item.id,
      title: item.title,
      description: item.description,
      image_url: item.image_url,
      mobile_image_url: item.mobile_image_url,
      link_url: item.link,
      active: Boolean(item.active),
      position: item.position,
      category_id: item.category_id || null,
      container_products: {
        container2: item.product_id || null,
        container3: item.product_id_2 || null,
        container4: item.product_id_3 || null,
        container5: item.product_id_4 || null
      }
    };
  },
  
  deleteSliderItem: async (id: string) => {
    const response = await api.delete(`/slider/${id}`);
    return response.data;
  },
  
  updateSliderOrder: async (items: SliderOrderItem[]) => {
    const response = await api.post('/slider/order', { items });
    return response.data;
  }
};